import { render, staticRenderFns } from "./download-products.vue?vue&type=template&id=b86cb48c"
import script from "./download-products.vue?vue&type=script&lang=js"
export * from "./download-products.vue?vue&type=script&lang=js"
import style0 from "./download-products.vue?vue&type=style&index=0&id=b86cb48c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports